// extracted by mini-css-extract-plugin
module.exports =  {"defaultIconButton":"style-module_defaultIconButton__Ruhumqkoh2MAB_l_VrHo","copyValue":"style-module_copyValue__US4WOx896SQITTUb8IEP"};